module.exports = __webpack_public_path__ + "static/media/uiseed.d0a4124d.png";